import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addLocaleData, IntlProvider } from 'react-intl'
import Registration from './Registration'

import { fetchConferenceDetails, registerEmail } from './actions'

import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'

import messages from '../../messages'
import { checkJapanese, flattenMessages } from '../../lib'

// Language dependencies
addLocaleData([...en, ...ja])

class RegistrationContainer extends Component {
  componentDidMount () {
    const {id} = this.props.match.params
    this.props.fetchConferenceDetails(id)
  }

  render () {
    return (
      <IntlProvider
        locale={checkJapanese() ? 'ja' : 'en'}
        messages={flattenMessages(
          messages[checkJapanese() ? 'ja' : 'en']
        )}
      >
        <Registration id={this.props.match.params.id} {...this.props} />
      </IntlProvider>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetchingConferenceDetails: state.registration.isFetchingConferenceDetails,
  conferenceDetails: state.registration.conferenceDetails,
  isRequestingRegisteration: state.registration.isRequestingRegisteration,
  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  fetchConferenceDetails: (token, conferenceId, guest) =>
    dispatch(fetchConferenceDetails(token, conferenceId, guest)),
  registerEmail: (email, id) => dispatch(registerEmail(email, id))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  RegistrationContainer
)



// WEBPACK FOOTER //
// ./src/routes/Registration/RegistrationContainer.js